import { render, staticRenderFns } from "./EdenLocationSwitch.vue?vue&type=template&id=038605d7&scoped=true"
import script from "./EdenLocationSwitch.vue?vue&type=script&lang=js"
export * from "./EdenLocationSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038605d7",
  null
  
)

export default component.exports